const hasAllowedRole = (allowedRoles = [], userRoles = []) => {
  if (userRoles === null) userRoles = [];
  return userRoles.some((role) => allowedRoles.includes(role));
};

export default hasAllowedRole;
